function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.7 4.3c-.4-.4-1-.4-1.4 0L9 17.6l-7.3-7.3c-.4-.4-1-.4-1.4 0-.2.1-.3.4-.3.7 0 .3.1.5.3.7l8 8c.2.1.5.3.7.3h.1c.2 0 .5-.1.7-.3l14-14c.3-.4.3-1-.1-1.4z"
});

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "76b5408409de54fd618622306206967d.svg";
export { SvgCheck as ReactComponent };